module.exports = __webpack_public_path__ + "img/41e2f83b63987e512c3fdb2393d7f752.png";